import {
  CONFIRM_UNSUBSCRIBE_FAILED,
  CONFIRM_UNSUBSCRIBE_SUCCESS,
  GET_VERIFIED_SUBSCRIBER_FAILED,
  GET_VERIFIED_SUBSCRIBER_SUCCESS,
  UNSUBSCRIBE_CANCEL,
  UNSUBSCRIBE_FAIL,
  UNSUBSCRIBE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  unsubscribe: [],
  resetUnsub: null,
  verifiedSubscriber: null,
  unsubscribeConfirmed: null,
  resetUnSubState: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UNSUBSCRIBE_SUCCESS:
      return {
        ...state,
        unsubscribe: action.payload,
        resetUnsubState: action.payload,
      };
    case UNSUBSCRIBE_FAIL:
      return {
        ...state,
        unsubscribe: action.payload,
        resetUnsubState: null,
      };
    case UNSUBSCRIBE_CANCEL:
      return {
        ...state,
        resetUnsub: action.payload,
        resetUnsubState: null,
      };
    case GET_VERIFIED_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        verifiedSubscriber: action.payload,
      };
    case GET_VERIFIED_SUBSCRIBER_FAILED:
      return {
        ...state,
        verifiedSubscriber: null,
      };
    case CONFIRM_UNSUBSCRIBE_SUCCESS:
      return {
        ...state,
        unsubscribeConfirmed: action.payload,
      };
    case CONFIRM_UNSUBSCRIBE_FAILED:
      return {
        ...state,
        unsubscribeConfirmed: null,
      };
    default:
      return state;
  }
}
